import axios from 'axios'
import moment from 'moment'
class ApiService {
  constructor (pacNome) {
    console.log('CONSTRUCT ApiService')
    this.isOnline = true
    this.objOffline = {}

    this.pacNome = pacNome || null
  }

  /**
   * Verifica a conectividade com a internet .
   * Se o navegador estiver offline, salva os dados em um log. Quando a conexão é restaurada,
   * calcula o tempo de inatividade e salva os logs relacionados.
   * @async
   * @returns {Promise<void>} - Retorna void, mas registra logs de conexão conforme o estado.
   */
  async checkAndSaveConnection(cpf, protocol) {
    try {
      const response = await this.checkConnection();
      const payload = {
        type: 'INSERT',
        cpf: cpf || 'Não informado',
        origem: 'Portal Paciente SUS',
        protocol: protocol || null,
        pacNome: this.pacNome,
        payload: JSON.stringify(response),
        createdAt: null,
        subtype: 'Não informado',
      };

      if (response.online) {
        // Conexão restaurada após ficar offline
        if (response.restored) {
          console.warn('Conexão Restaurada.');

          // Log do tempo offline
          payload.payload = JSON.stringify(this.objOffline);
          payload.subtype = `Status da Conexão: Offline`;
          payload.createdAt = this.createdAtOffline;
          await this.saveTeleconsultMovimentLog(payload);

          // Calcula o tempo offline e cria log de restauração
          const createdAtOfflineMoment = moment(this.createdAtOffline, 'YYYY-MM-DD HH:mm:ss');
          const createdAtRestored = moment();
          const diffTimeInMinutes = createdAtRestored.diff(createdAtOfflineMoment, 'minutes');
          
          payload.payload = JSON.stringify(response);
          payload.subtype = `Status da Conexão: Restaurada. Tempo offline: ${diffTimeInMinutes} min`;
          payload.createdAt = createdAtRestored.format('YYYY-MM-DD HH:mm:ss');
          await this.saveTeleconsultMovimentLog(payload);

          // Limpa os dados offline
          this.objOffline = null;
          this.createdAtOffline = null;
        } else if (!this.isPreviouslyOnline) {
          // Primeiro log quando fica online
          console.warn('Online.');
          payload.subtype = 'Status da Conexão: Online';
          await this.saveTeleconsultMovimentLog(payload);
          this.isPreviouslyOnline = true; // Marca como online
        }
      } else {
        console.warn('Offline.');
        // Salva o estado quando vai offline pela primeira vez
        if (!this.objOffline) {
          this.objOffline = response;
          this.createdAtOffline = moment().format('YYYY-MM-DD HH:mm:ss');
          this.isPreviouslyOnline = false; // Marca como offline
        }
      }
    } catch (error) {
      console.error('Erro ao verificar a conexão:', error.message);
    }
  }

  /**
   * Verifica a conexão com o servidor, envia uma requisição para verificar
   * o estado atual da conexão (online ou offline).
   * @async
   * @returns {Promise<Object>} - Retorna um objeto com o estado da conexão
   * e informações sobre a restauração da conexão.
   */
  async checkConnection() {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/teleconsult/ping`;
    const wasOnline = this.isOnline; // Estado anterior da conexão
    try {
      let response = await axios.get(url);
      response = response.data;
      this.isOnline = true; // Atualiza o estado de conexão
      // Verifica se a conexão foi restaurada se estava offline antes
      const restored = !wasOnline && this.isOnline;
      return {
        online: this.isOnline,
        restored: restored, // Define se a conexão foi restaurada
        ...response,
        created_at: moment().format('DD/MM/YYYY - HH:mm:ss'),
      };
    } catch (error) {
      this.isOnline = false; // Define como offline em caso de erro
      const restored = wasOnline && !this.isOnline; // Verifica se a conexão foi perdida
      return {
        online: this.isOnline,
        restored: !restored, // Define como falso se a conexão foi perdida
        alive: false,
        error: error.message, // Retorna a mensagem de erro
        created_at: moment().format('DD/MM/YYYY - HH:mm:ss'),
      };
    }
  }

  async saveTeleconsultMovimentLog (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/teleconsult/save-log`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[saveTeleconsultMovimentLog]', err)
    }
  }

  async sendNotification (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/expo/notification`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[saveTeleconsultMovimentLog]', err)
    }
  }

  async saveTeleconsultRoom (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/rooms/save-room`;
    try {
      const resp = await axios.post(url, payload);
      return resp.data
    } catch (err) {
      console.error('[saveTeleconsultRoom]', err)
    }
  }
  async updateTeleconsultRoom (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/rooms/update-room`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[updateTeleconsultRoom]', err)
    }
  }
}

export default ApiService
